/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { useLang } from '~/hooks/useLang';
import useDispatchRegistrationState from '../../stores/DispatchRegistrationState';
import { AppBar, Box, Button, Card, CircularProgress, Container, Divider, Grid, IconButton, Tab, Tabs, Tooltip, Typography, useTheme } from '@mui/material';
import DraggableDelete from './components/ConfirmDelete';
import TabPanel from './components/TabPanel';
import Person from '../DispatchRegistrationPeople';
import Vehicle from '../DispatchRegistrationVehicle';
import Weapon from '../DispatchRegistrationWeapon';
import Drug from '../DispatchRegistrationDrug';
import Object from '../DispatchRegistrationObject';
import Organs from '../DispatchRegistrationOrgans';
import useSystemState from '~/features/System/stores/SystemState';
import useDispatchState from '../../stores/DispatchState';
import Animal from '../DispatchRegistrationAnimal';
import Others from '../DispatchRegistrationOthers';
import useDispatchFormBuilderState from '../../stores/useDispatchFormBuilderState';
import { Downgraded, useHookstate } from '@hookstate/core';
import type { formFields, FormGroup, IFormBuilder, ISendformValues } from '../../interfaces/IDispatchFormBuilder';
import FormGroupTitle from '../DispatchRegistrationPeople/components/FormBuilderOccurrencePeople/FormGroupTitle';
import { LoadingButton } from '@mui/lab';
import FormBuilderOccurrencePeople from '../DispatchRegistrationPeople/components/FormBuilderOccurrencePeople';
import ActionsButtons from '../DispatchRegistrationPeople/components/FormBuilderOccurrencePeople/ActionsButtons';
import { Print } from '@mui/icons-material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useHistory } from "react-router";


// eslint-disable-next-line max-lines-per-function
export default function RegistrationTab() {
  const { translate } = useLang();
  const theme = useTheme();
  const history = useHistory();
  const { systemConfig } = useSystemState();
  const { windowManager } = useSystemState();
  const dispatchState = useDispatchState()
  const dispatchStatus = dispatchState.dispatch()?.status?.id.get();
  const { registrationDispatch } = useDispatchRegistrationState();
  const { formBuilder, formBuilderConfig, saveForm, getFormWithValues } = useDispatchFormBuilderState();
  const loadingForms = useHookstate<boolean>(false);
  const formValues = useHookstate<ISendformValues[] | null>(null);
  const isChangingTab = useHookstate<boolean>(false);
  const formBuilderId = useHookstate<number | null>(null);
  const {
    registrationActiveTab,
    registrationRowId,
    addRegistration,
    deleteRegistration,
    openConfirmAction,
    actionName,
    externalAction,
    externalActionName,
    openForm,
    registrationActiveFormtab,
  } = registrationDispatch()

  function parseFieldValue(field: formFields): formFields['value'] {
    switch (field.type) {
      case 'boolean':
        if (field.value === 'true') return true;
        if (field.value === 'false') return false;
        return field.value;
      case 'string':
        return field.value ? String(field.value) : null;
      case 'body-markings':
        if (!field.value) return null;
        try {
          return JSON.parse(field.value);
        } catch {
          console.error('Erro ao fazer parse do body-markings:', field.value);
          return null;
        }
      default:
        return field.value;
    }
  }

  function convertFormFieldValues(form: IFormBuilder): IFormBuilder {
    return {
      ...form,
      form_groups: form.form_groups.map(group => ({
        ...group,
        form_fields: group.form_fields.map(field => ({
          ...field,
          value: parseFieldValue(field),
        })),
      })),
    };
  }

  async function fetchForms(idForm?) {
    loadingForms.set(true);
    try {
      const builderConfig = formBuilderConfig().attach(Downgraded).get();
      if (idForm) {
        const formFetch = builderConfig.find((item) => item?.form?.id === idForm);

        if (!formFetch) return;
        const response: IFormBuilder = await getFormWithValues({ itemId: Number(registrationRowId.get()), formId: formFetch?.form?.id });

        const convertedForm = convertFormFieldValues(response);
        if (formBuilder()[idForm]) {
          formBuilder()?.merge([convertedForm]);
        }
      } else {
        const responses = await getFormWithValues({ itemId: Number(registrationRowId.get()), formId: builderConfig[0].form?.id })
        formBuilder().set([responses].map(convertFormFieldValues));
      }
    } finally {
      loadingForms.set(false);
    }
  }

  useEffect(() => {
    if (openForm.get() && registrationRowId.get()) {
      fetchForms();
    }

    return () => {
      registrationActiveFormtab.set(0);
    };
  }, [openForm.value]);

  const formatedValeuToSend = ({ fieldType, value }) => {
    switch (fieldType) {
      case 'boolean':
        return Boolean(fieldType.value);
      case 'number':
        return Number(value);
      case 'float':
        return parseFloat(value)
      case 'body-markings':
        if (value) {
          return JSON.stringify(value);
        } else {
          return value;
        };
      case 'string':
        return value ? String(value) : null
      default:
        return value
    }

  }

  const sendFormToSave = async (formId) => {
    formValues.set(null)
    const formToSend = formBuilder()?.get()?.find((form) => form.id === formId);
    if (!formToSend) return;

    const values: ISendformValues[] = [];
    formToSend.form_groups.forEach((formGroup) => {
      formGroup.form_fields.forEach((field) => {
        // eslint-disable-next-line functional/immutable-data
        values.push({
          form_field_id: Number(field.id),
          value: formatedValeuToSend({ fieldType: field.type, value: field.value })
        });
      });
    });
    formValues.set(values);

    await saveForm({
      itemId: Number(registrationRowId.get()),
      formValues: values
    }).finally(() => {
      fetchForms(Number(formToSend?.id));
    });
  };

  const handleClickOpenConfirmAction = (action = 'cancel') => {
    actionName.set(action)
    openConfirmAction.set(true);
  };

  const handleCloseConfirmAction = () => {
    openConfirmAction.set(false);
    externalAction.set(false)
  };

  const handleConfirm = () => {
    if (actionName.get() === 'delete') {
      deleteRegistration.set(true)
      openConfirmAction.set(false);
      addRegistration.set(false)
      return
    }
    openConfirmAction.set(false);
    registrationRowId.set('')
    addRegistration.set(false)

    if (externalAction.get() && externalActionName.get() === 'previous') {
      dispatchState.previousDispatch()
      windowManager()['registration'].open.set(false)
      windowManager()['dispatchProcedure'].open.set(false)
      windowManager()['dispatchProcedure'].procedure.set([])
      externalAction.set(false)
    }

    if (externalAction.get() && externalActionName.get() === 'next') {
      dispatchState.nextDispatch()
      windowManager()['registration'].open.set(false)
      windowManager()['dispatchProcedure'].open.set(false)
      windowManager()['dispatchProcedure'].procedure.set([])
      externalAction.set(false)
    }
    return
  }

  function a11yProps(index: number) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }

  const handleChangeFormTab = async (event: React.SyntheticEvent, newValue: number) => {
    formBuilderId.set(newValue)
    if (addRegistration.get() || registrationActiveFormtab.get() === formBuilderId.get() || isChangingTab.get()) {
      return
    }

    isChangingTab.set(true)

    try {
      const builderConfig = formBuilderConfig().attach(Downgraded).get();
      const existingForm = formBuilder().get()?.find((form) => form.id === builderConfig[Number(formBuilderId.get())].form?.id);

      if (!existingForm) {
        const responses = await getFormWithValues({ itemId: Number(registrationRowId.get()), formId: builderConfig[Number(formBuilderId.get())].form?.id })
        formBuilder().merge([responses].map(convertFormFieldValues));
      }

      registrationActiveFormtab.set(newValue);
    } finally {
      isChangingTab.set(false)
    }
  }

  const handleChange = async (event: React.SyntheticEvent, newValue: number) => {
    if (addRegistration.get()) {
      return
    }
    registrationActiveTab.set(newValue);
  };

  const handleChangeIndex = (index: number) => {
    registrationActiveTab.set(index);
  };

  const backToRegistration = () => {
    openForm.set(false)
  }

  const handlePrintFormBuilder = () => {
    const dispatchId = dispatchState.dispatch().id.get();
    const itemId = registrationRowId.get();
    const formId = formBuilderConfig()[registrationActiveFormtab.get()].get()?.form?.id;
    const url = `/dispatch/print-form/${dispatchId}/${itemId}/${formId}`;

    window.open(url);
  }

  return (
    <Container
      component="main">
      {openConfirmAction && <DraggableDelete
        actionName={actionName.get()}
        handleAbort={handleCloseConfirmAction}
        handleConfirm={handleConfirm}
        open={openConfirmAction.get()}
      />}
      <AppBar position="static" color="transparent">
        {openForm.get() ?
          <Tabs
            selectionFollowsFocus
            value={registrationActiveFormtab.get()}
            onChange={handleChangeFormTab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            aria-label="registrations"
            scrollButtons={true}
          >
            {formBuilderConfig().get().map((form, index) => (
              form.item_type === "occurrence_people" &&
              <Tab key={form.id} label={translate(String(form.form?.name))} disabled={loadingForms.get()} sx={{
                width: '100%',
                whiteSpace: 'nowrap',
                wordWrap: 'break-word',
              }} {...a11yProps(index)} />
            ))}
          </Tabs>
          :
          <Tabs
            selectionFollowsFocus
            value={registrationActiveTab.get()}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="registrations"
          >
            <Tab label={translate('Person')} {...a11yProps(0)} />
            <Tab label={translate('Vehicle')} {...a11yProps(1)} />
            <Tab label={translate('Weapons')} {...a11yProps(2)} />
            <Tab label={translate('Drugs')} {...a11yProps(3)} />
            <Tab label={translate('Objects')} {...a11yProps(4)} />
            <Tab label={translate('Organs')} {...a11yProps(5)} />
            <Tab label={translate('Animals')} {...a11yProps(6)} />
            {systemConfig().featureToPocRs.get() === '1' &&
              <Tab label={translate('Others')} {...a11yProps(7)} />
            }
          </Tabs>
        }
      </AppBar>
      {openForm.get() ?
        <>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={registrationActiveFormtab.get()}
            disabled={true}
          >
            {!loadingForms.get() && formBuilder().get().length > 0 ?
              formBuilder().get().map((form: IFormBuilder, indexForm) => (
                <>
                  <Card sx={{ maxHeight: 550, overflowY: 'auto' }}>
                    {form.form_groups?.map((formGroups: FormGroup, indexGroup) => {
                      return (
                        <>
                          <FormGroupTitle title={String(formGroups.name)} />
                          <TabPanel
                            value={registrationActiveFormtab.get()}
                            index={indexForm}
                            dir={theme.direction}
                          >
                            <FormBuilderOccurrencePeople
                              dataForm={formBuilder()[indexForm].form_groups[indexGroup].form_fields} />
                          </TabPanel>
                        </>
                      );
                    })}
                    <ActionsButtons
                      loadingForms={loadingForms}
                      sendFormToSave={() => sendFormToSave(form.id)}
                      onCancel={() => {
                        registrationActiveFormtab.set(0);
                        openForm.set(false);
                      }} />
                  </Card>
                </>
              ))
              : loadingForms.get() ?
                <Grid container width={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{ height: 500 }}>
                  <CircularProgress />
                </Grid>
                :
                <Typography>
                  Nenhum formulário encontrado.
                </Typography>}
          </SwipeableViews>
          <Divider flexItem />
          <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'} gap={2} marginTop={2}>
            <Tooltip title={translate('Back')}>
              <IconButton onClick={() => backToRegistration()}>
                <ArrowBackIosNewIcon />
              </IconButton>
            </Tooltip>
            {dispatchStatus === 8 && (
              <Tooltip title={translate('Print Form')}>
                <IconButton onClick={() => handlePrintFormBuilder()}>
                  <Print />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </>
        :
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={registrationActiveTab.get()}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel value={registrationActiveTab.get()} index={0} dir={theme.direction}>
            <Person
              handleClickOpenConfirmAction={handleClickOpenConfirmAction}
            />
          </TabPanel>
          <TabPanel value={registrationActiveTab.get()} index={1} dir={theme.direction}>
            <Vehicle
              handleClickOpenConfirmAction={handleClickOpenConfirmAction}
            />
          </TabPanel>
          <TabPanel value={registrationActiveTab.get()} index={2} dir={theme.direction}>
            <Weapon
              handleClickOpenConfirmAction={handleClickOpenConfirmAction}
            />
          </TabPanel>
          <TabPanel value={registrationActiveTab.get()} index={3} dir={theme.direction}>
            <Drug
              handleClickOpenConfirmAction={handleClickOpenConfirmAction}
            />
          </TabPanel>
          <TabPanel value={registrationActiveTab.get()} index={4} dir={theme.direction}>
            <Object
              handleClickOpenConfirmAction={handleClickOpenConfirmAction}
            />
          </TabPanel>
          <TabPanel value={registrationActiveTab.get()} index={5} dir={theme.direction}>
            <Organs
              handleClickOpenConfirmAction={handleClickOpenConfirmAction}
            />
          </TabPanel>
          <TabPanel value={registrationActiveTab.get()} index={6} dir={theme.direction}>
            <Animal
              handleClickOpenConfirmAction={handleClickOpenConfirmAction}
            />
          </TabPanel>
          <TabPanel value={registrationActiveTab.get()} index={7} dir={theme.direction}>
            <Others
              handleClickOpenConfirmAction={handleClickOpenConfirmAction}
            />
          </TabPanel>
        </SwipeableViews>
      }
    </Container>
  );
}